import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { MdEmail, MdLocationOn, MdPhone } from "react-icons/md";
import logo from "../assets/logo-orange.svg";
const mainNavigation = [
  { title: "\xDCber uns", link: "/about" },
  { title: "Resort", link: "/hiru-villa" },
  { title: "Ayurveda", link: "/ayurveda/panchakarma" },
  { title: "Aktivit\xE4ten", link: "/activities" },
  { title: "Touren", link: "/tours" },
  { title: "Kontakt", link: "/contact-us" }
];
const quickLinks = [
  { title: "Hiru Villa", link: "/hiru-villa" },
  { title: "Hiru Om", link: "/hiru-om" },
  { title: "Hiru Mudra", link: "/hiru-mudra" },
  { title: "Hiru Aadya", link: "/hiru-aadya" },
  { title: "Panchakarma", link: "/ayurveda/panchakarma" },
  { title: "Ayurveda-Ern\xE4hrung", link: "/ayurveda/food" },
  { title: "Spirituelle Reise", link: "/ayurveda/spiritual-journey" },
  { title: "Jetzt buchen", link: "/search" },
  { title: "Kontakt aufnehmen", link: "/contact-us" }
];
const Footer = () => {
  const socialLinks = [
    {
      name: "Facebook",
      link: "https://www.facebook.com/ayurvedasrilanka",
      icon: FaFacebookF
    },
    {
      name: "Instagram",
      link: "https://www.instagram.com/hiru_resorts/?hl=en",
      icon: FaInstagram
    },
    {
      name: "WhatsApp",
      link: "https://wa.me/94767744180",
      icon: FaWhatsapp
    }
  ];
  return <section className="relative overflow-hidden bg-[radial-gradient(circle_at_top_left,rgba(242,134,0,0.18),transparent_30%),radial-gradient(circle_at_bottom_right,rgba(36,75,12,0.18),transparent_32%),linear-gradient(180deg,#112b1e_0%,#0c2016_46%,#07130d_100%)] py-10 text-white sm:py-12 lg:py-16 xl:py-20">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-10 top-0 h-40 w-40 rounded-full bg-[#F28600]/18 blur-3xl sm:h-52 sm:w-52 lg:h-72 lg:w-72" />
        <div className="absolute -right-12 bottom-0 h-48 w-48 rounded-full bg-[#244B0C]/18 blur-3xl sm:h-56 sm:w-56 lg:h-80 lg:w-80" />
      </div>

      <div className="relative z-10 mx-auto max-w-[1180px] px-4 sm:px-6 lg:px-8 xl:px-10">
        <footer className="rounded-2xl border border-white/15 bg-white/6 p-5 shadow-[0_30px_80px_rgba(0,0,0,0.28)] backdrop-blur-sm sm:p-7 lg:p-10 xl:p-12">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8 xl:gap-10">
            <div className="min-w-0">
              <img
    src={logo}
    alt="Garden Beach Ayurveda Resort"
    className="h-auto w-[120px] sm:w-[135px] lg:w-[160px]" loading="lazy" />
              <p className="mt-4 max-w-lg text-sm leading-relaxed text-amber-50/85 sm:text-[15px]">
                Ein ruhiger Rückzugsort am Strand von Sri Lanka, wo Ayurveda und Wellness in entspannter Atmosphäre erlebt werden.
              </p>

              <div className="mt-5 flex flex-wrap items-center gap-2.5">
                {socialLinks.map((item) => <a
    key={item.name}
    href={item.link}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={item.name}
    className="flex h-9 w-9 items-center justify-center rounded-full border border-white/20 bg-white/8 text-amber-50/90 transition-all duration-200 hover:border-[#F28600]/70 hover:bg-[#F28600] hover:text-white"
  >
                    <item.icon className="h-4 w-4" />
                  </a>)}
              </div>
            </div>

            <div className="min-w-0">
              <h4 className="text-sm font-semibold uppercase tracking-[0.12em] text-amber-100 sm:text-base">
                Navigation
              </h4>
              <div className="mt-4 flex flex-col items-start gap-2.5">
                {mainNavigation.map((item) => <Link
    key={item.link}
    className="text-sm text-amber-50/85 transition-colors duration-200 hover:text-white sm:text-[15px]"
    to={item.link}
  >
                    {item.title}
                  </Link>)}
              </div>
            </div>

            <div className="min-w-0">
              <h4 className="text-sm font-semibold uppercase tracking-[0.12em] text-amber-100 sm:text-base">
                Schnelllinks
              </h4>
              <div className="mt-4 grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-1">
                {quickLinks.map((item) => <Link
    key={item.title}
    className="text-sm text-amber-50/85 transition-colors duration-200 hover:text-white sm:text-[15px]"
    to={item.link}
  >
                    {item.title}
                  </Link>)}
              </div>
            </div>

            <div className="min-w-0">
              <h4 className="text-sm font-semibold uppercase tracking-[0.12em] text-amber-100 sm:text-base">
                Kontakt
              </h4>
              <div className="mt-4 space-y-3 text-sm text-amber-50/85 sm:text-[15px]">
                <div className="flex items-start gap-2.5">
                  <MdLocationOn className="mt-0.5 h-4 w-4 shrink-0 text-amber-200 sm:h-5 sm:w-5" />
                  <span className="leading-relaxed">
                    <a
    href="https://maps.app.goo.gl/fAocAzqfYBbMk6Gc8"
    target="_blank"
    rel="noopener noreferrer"
    className="transition-colors duration-200 hover:text-white"
  >
                      Kudawa Mountain Road, Maggona – Kalutara, Sri Lanka
                    </a>
                  </span>
                </div>

                <a
    href="tel:+94767744180"
    className="flex items-center gap-2.5 transition-colors duration-200 hover:text-white"
  >
                  <MdPhone className="h-4 w-4 shrink-0 text-amber-200 sm:h-5 sm:w-5" />
                  <span>+94 (0)76 774 4180</span>
                </a>

                <a
    href="mailto:info@hiru-ayurveda-resorts.com"
    className="flex items-center gap-2.5 break-all transition-colors duration-200 hover:text-white lg:whitespace-nowrap"
  >
                  <MdEmail className="h-4 w-4 shrink-0 text-amber-200 sm:h-5 sm:w-5" />
                  <span className="lg:whitespace-nowrap">info@hiru-ayurveda-resorts.com</span>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-8 border-t border-white/10 pt-5 sm:mt-10 sm:pt-6">
            <div className="flex flex-col gap-4 text-xs text-amber-50/80 sm:text-sm lg:flex-row lg:items-center lg:justify-between">
              <div className="font-mulish">
                <h6 className="leading-relaxed">
                  Urheberrecht {(/* @__PURE__ */ new Date()).getFullYear()} Hiru Ayurveda Resorts (PVT) Limited
                </h6>
                <p className="mt-1 leading-relaxed">Entwickelt von: Redev Solutions (+94 76 460 8225)</p>
              </div>

              <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                <Link
    className="transition-colors duration-200 hover:text-white"
    to="/contact-us"
  >
                  Kontakt
                </Link>
                <Link
    className="transition-colors duration-200 hover:text-white"
    to="/search"
  >
                  Jetzt buchen
                </Link>
                <a
    className="transition-colors duration-200 hover:text-white"
    href="https://gardenbeachayurveda.com"
    target="_blank"
    rel="noopener noreferrer"
  >
                  Offizielle Website
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </section>;
};
export default Footer;
